import { set } from "idb-keyval";
import { sortBy } from "lodash";
import Paho from "paho-mqtt";
import { v1 as uuidv1 } from "uuid";
import { Tracing } from "../../../App.tracing";
import defaultSetup from "../../../Config/defaultSetupConfiguration";
import { storeCatchupDoneEvent } from "./Catchup/StoreCatchupDoneEvents";
import { configureStore, getEventTime, sendEvent } from "./SendEvent";
import SequenceIdGenerator from "./SequenceIdGenerator";
import { createBaseEvent } from "./CreateBaseEvent.js";
import { convertDisplayTimeToDataTime } from "./ConvertClock.js";

const idGenerator = SequenceIdGenerator.getInstance();

export function sendClockEvent(eventClass, type, subType, props, option = null, value = null) {
  const { currentState, updateState } = props;
  const fixtureId = props.currentState.fixtureId;
  const isPeriodStartOrEnd = eventClass === "sport" && type === "period" && ["start", "end"].includes(subType);

  const eventStore = configureStore(props, "event");
  const playStore = configureStore(props, "play");

  let msg = {};
  msg.class = eventClass;
  msg.eventType = type;

  if (subType) {
    msg.subType = subType;
  }

  if (option && subType !== "adjust") {
    msg.options = {
      option: value,
    };
  } else if (option && subType === "adjust") {
    msg.options = {
      value: value,
    };
  }

  if (isPeriodStartOrEnd) {
    msg.playId = uuidv1();
  }

  const isFixtureEnd = msg.eventType === "fixture" && msg.subType === "end";

  if (isFixtureEnd) {
    // when we confirm a period the clock gets reset to 0, that's why for fixture end we need to get last correct period's clock
    const allPeriodEnds = props.eventStore.filter((e) => e.eventType === "period" && e.subType === "end");
    const sortedPeriodEnds = sortBy(allPeriodEnds, (e) => e.periodId);
    const lastPeriodEnd = sortedPeriodEnds.at(-1);
    msg.clock = lastPeriodEnd.clock;
  }

  if (msg.class === "clock" || isPeriodStartOrEnd) {
    msg.clock = getClockTimeFromState(props.currentState);
  }

  msg.eventId = uuidv1();
  msg.status = "added";
  msg.periodId = currentState.period ? currentState.period.periodId : 1;

  let timestamp = new Date();
  msg.timestamp = timestamp.toISOString();
  msg.eventTime = getEventTime();
  msg.sequence = idGenerator.getId();

  let messageContent = JSON.stringify({
    type: "event",
    fixtureId: fixtureId,
    data: msg,
    clientType: defaultSetup.options.clientType,
  });

  if (!currentState.processing) {
    var message = new Paho.Message(messageContent);
    if (currentState.mqtt) {
      message.destinationName = currentState.mqtt.topic;
      if (currentState.connected && currentState.mqttConnected) {
        try {
          currentState.mqtt.client.send(message);
          storeCatchupDoneEvent(msg, currentState, updateState);
        } catch (err) {
          Tracing.capture(err);
          console.error("Send Error", err);
        }
      }
      msg.pending = true;
      props.manageEvents(msg.eventId, msg);
      set(msg.eventId, msg, eventStore);

      if (isPeriodStartOrEnd) {
        let playObject = {
          playId: msg.playId,
          eventTime: msg.eventTime,
          clock: msg.clock,
          periodId: msg.periodId,
        };

        props.managePlays(msg.playId, playObject);
        set(msg.playId, playObject, playStore);
      }
    }
  }
}

export const getClockTimeFromState = (currentState) => {
  if (!currentState?.clock?.displayTime) return null;
  const clockParts = currentState.clock.displayTime.split(":");
  const result = "PT" + parseInt(clockParts[0]) + "M" + parseInt(clockParts[1]) + "S";
  return result;
};

export function sendCountdownClockEvent(props, subType, newValue) {
  const action = createBaseEvent(props.currentState);
  action.event.class = "clock";
  action.event.eventType = "countDown";
  action.event.subType = subType;
  action.event.clock = convertDisplayTimeToDataTime(props.currentState.clock.displayTime);

  if (subType === "adjust") {
    action.event.options = {
      value: newValue,
    };
  }

  sendEvent(action, props);
}
